import { useQuery } from '@tanstack/react-query';

import { createQueryOptions } from '../../query';
import { useStoreApi } from '../api';
import { storeKeys } from '../query-key-factory';
import { StoreCause, StoreCauseResponse, StoreCauseSearch } from './cause.types';

const useShowStoreCause = <T = StoreCause>({
  causeId,
  queryOptions,
  select,
}: {
  causeId?: string;
  queryOptions?: StoreCauseSearch;
  select?: (data: StoreCause) => T;
}) => {
  const StoreApi = useStoreApi();

  const getStoreCause = async () => {
    const { queryString } = createQueryOptions<StoreCauseSearch>({
      search: queryOptions,
    });

    const { data } = await StoreApi.get<StoreCauseResponse>(`/cause/${causeId}?${queryString}`);

    return data.cause;
  };

  const queryKey = causeId ? storeKeys.id(causeId).causes.id(causeId).detail : [];

  return useQuery({
    queryKey: [...queryKey, queryOptions],
    queryFn: getStoreCause,
    enabled: !!causeId,
    select,
  });
};

export { useShowStoreCause };
